import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type { SpaceAccess } from '@eggplant/types'

interface Props {
  spaceId: string
  spinnerSize?: number
  children?: (response: SpaceAccess) => ReactElement
  onSuccess?: (response: SpaceAccess) => void
  onError?: () => void
}

const GetSpaceAccessControlRequest = ({
  spaceId,
  spinnerSize,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${ACL_SERVICE}/acls/space/${spaceId}/current_user`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={spinnerSize}
      url={url}
    />
  )
}

export default GetSpaceAccessControlRequest
